module.exports = __webpack_public_path__ + "static/media/productimagenew.ea570e80.png";